import { graphql } from 'gatsby'
import React, { useEffect, useState } from 'react'
import ColumnBackAndForth from '../../../components/atoms/columnBackAndForth'
import SEO from '../../../components/atoms/seo'
import { ITopicPath } from '../../../components/atoms/topicPath'
import Conclusion001 from '../../../components/molecules/Conclusion001'
import Conclusion002 from '../../../components/molecules/Conclusion002'
import Conclusion003 from '../../../components/molecules/Conclusion003'
import Conclusion004 from '../../../components/molecules/Conclusion004'
import Conclusion005 from '../../../components/molecules/Conclusion005'
import Conclusion006 from '../../../components/molecules/Conclusion006'
import Conclusion007 from '../../../components/molecules/Conclusion007'
import Conclusion008 from '../../../components/molecules/Conclusion008'
import Conclusion009 from '../../../components/molecules/Conclusion009'
import CarouselBanner from '../../../components/molecules/carouselBanner'
import ColumnAuthor001 from '../../../components/molecules/columnAuthor001'
import ColumnDetailInner0085 from '../../../components/molecules/columnDetailInner0085'
import PopupBanner from '../../../components/molecules/popupBanner'
import UsefulFunctionLayout019 from '../../../components/molecules/usefulFunctionLayout019'
import ColumnDetailsBody from '../../../components/organisms/columnDetailsBody'
import ColumnLayout from '../../../components/organisms/columnLayout'

/**
 * コラム記事詳細画面
 * @constructor
 */
const C0085 = () => {
  const paths: ITopicPath[] = [
    { title: 'キンクラコラムTOP', link: '/column' },
    { title: 'コラム記事一覧', link: '/column/list' },
    {
      title: '「働き方」の次は「休み方」！「休み方改革」とは？',
    },
  ]

  // 0~8ランダム数字を保存
  const [no, setNo] = useState(-1)
  useEffect(() => {
    setNo(Math.floor(Math.random() * 9))
  }, [])

  return (
    <ColumnLayout paths={paths}>
      <SEO
        title="「働き方」の次は「休み方」！「休み方改革」とは？"
        description="「休み方改革」の必要性を解説。働き方に伴う新しい休息の取り方を提案し、企業文化の変革を促進します。"
        ogUrl="https://kintaicloud.jp/column/details/C0085/"
        ogType="article"
        ogTitle="「働き方」の次は「休み方」！「休み方改革」とは？"
        ogDescription="「休み方改革」の必要性を解説。働き方に伴う新しい休息の取り方を提案し、企業文化の変革を促進します。"
        ogSiteName="キンクラ - 客先常駐特化型のクラウド勤怠管理システム"
        ogImage="https://www.kintaicloud.jp/images/column/details/C0085/"
      />
      <ColumnDetailsBody>
        {/** ポップアップバナー */}
        <PopupBanner />
        {/** 記事本体 */}
        <ColumnDetailInner0085 no={no} />

        {/** ここに9パターンの広告設定する */}
        {no === 0 && <Conclusion001 />}
        {no === 1 && <Conclusion002 />}
        {no === 2 && <Conclusion003 />}
        {no === 3 && <Conclusion004 />}
        {no === 4 && <Conclusion005 />}
        {no === 5 && <Conclusion006 />}
        {no === 6 && <Conclusion007 />}
        {no === 7 && <Conclusion008 />}
        {no === 8 && <Conclusion009 />}

        {/** オーサ情報 */}
        <ColumnAuthor001 />
        {/** お役立ち機能 */}
        <UsefulFunctionLayout019 />
        {/** 前後記事への遷移 */}
        <ColumnBackAndForth />
        {/** カルーセルバナー */}
        <CarouselBanner />
        {/** 関連記事 */}
      </ColumnDetailsBody>
    </ColumnLayout>
  )
}

export default C0085

export const pageQuery = graphql`
  query C0085 {
    site {
      siteMetadata {
        title
      }
    }
  }
`
